<template>
  <div>
    <v-data-table
      :items="segments"
      :headers="headers"
      :rows-per-page-items="[20,50,100]"
      class="metro-table"
      hide-actions
      disable-initial-sort
      hide-headers
    >
      <template slot="headerCell" slot-scope="props">
        <v-tooltip bottom>
          <span slot="activator">{{ props.header.text }}</span>
          <span>{{ props.header.text }}</span>
        </v-tooltip>
      </template>

      <template slot="items" slot-scope="props">
        <td>
          <v-btn
            flat
            class="text-left btn-link"
            :to="{ path: '/segment/'+props.item.id}"
            @mouseover="mouseover(props.item)"
          >
            <v-icon
              class="hidden-sm-and-down"
              :class="hoverItem && hoverItem.id === props.item.id ? 'accent-dark' :'invisible'"
              @mouseover="zoom(props.item)"
            >zoom_in</v-icon>
            <img
              :src="$ic.getImageUrl('profile', profiler.calcProfile(props.item.segment))"
              class="small-thumbnail"
              :class="props.item.segment.climb_category !== 0 ? 'image-color-warning' : 'image-accent-dark'"
            >
            <span :title="props.item.name" class="btn-list-text">{{ props.item.name }}</span>
          </v-btn>
        </td>
        <td
          class="text-xs-right"
          v-html="$bc.speedFormat(props.item.distance/props.item.elapsed_time)"
        />

        <td
          class="text-xs-right hidden-xs-only"
          v-html="$bc.distanceFormat(props.item.distance,'minor')"
        />
        <td
          class="text-xs-right hidden-sm-and-down"
          v-html="$bc.elevationFormat(props.item.elevation, true)"
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import profiler from '@/domain/ProfileAnalyzer';
import eventBus from '@/events/eventBus';

export default {
  name: 'activity-segments',
  props: {
    segments: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data: () => ({
    profiler,
    hoverItem: null,
    headers: [
      { text: 'Name', value: 'name' },
      { text: 'Speed', value: 'elapsed_time' },
      { text: 'Elevation', value: 'elevation', align: 'right' },
      { text: 'Distance', value: 'distance', align: 'right' },
    ],
  }),
  watch: {
    segments() {
      if (this.segments) {
        this.segments.forEach((s) => {
          s.elevation = profiler.calcElevationDelta(s.segment);
        });
      }
    },
  },
  methods: {
    zoom(a) {
      this.$emit('item-hover', a);
    },
    mouseover(a) {
      this.hoverItem = a;
    },
  },
};
</script>

<style scoped>
</style>
